import styles from "./styles/SchoolsDropdown.module.scss";
import FontAwesome from "../utilities/FontAwesome";
import {useState} from "react";
import ClickableLink from "../utilities/ClickableLink";
import classNames from 'classnames';
import {CSSTransition} from "react-transition-group";
import {Arrow} from "../utilities/Popup";
import useClickOutside from "../../hooks/useClickOutside";

const transitionClassNames = {
    enter: styles.transitionEnter,
    enterActive: styles.transitionEnterActive,
    enterDone: styles.transitionEnterDone,
    exit: styles.transitionExit,
    exitActive: styles.transitionExitActive,
    exitDone: styles.transitionExitDone,
};

export function SchoolsDropdown(props: {
    heroBlock: IHeroTerraceBlock
}) {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const ref = useClickOutside(() => setDropdownOpen(false));

    const arrowClassName = classNames({
        [styles.arrow]: true,
        [styles.arrowVisible]: dropdownOpen,
    })

    return <div className={styles.container} ref={ref}>
        <CSSTransition classNames={transitionClassNames} in={dropdownOpen} timeout={250} mountOnEnter={true}>
            <div className={styles.dropdown}>
                <ul>
                    {props.heroBlock.school_links?.map(link => {
                        return <li>
                            <ClickableLink href={link.url}>{link.title}</ClickableLink>
                        </li>
                    })}
                </ul>
            </div>
        </CSSTransition>
        <Arrow position={"bottom"} className={arrowClassName} />
        <button onClick={() => setDropdownOpen(v => !v)}>
            <span>OUR SCHOOLS&nbsp;</span><FontAwesome prefix={"fas"} name={"fa-arrow-up"} />
        </button>
    </div>
}